/* @ngInject */
export function HelpService($http, $q, Notifier, PresentationReview, Video, API_BASE, Helpers, DATE_TYPE) {
    var _this = this;
    //so far, empty
}
